import { render, staticRenderFns } from "./confirm-consolidation.vue?vue&type=template&id=048a00a6&scoped=true"
import script from "./confirm-consolidation.vue?vue&type=script&lang=js"
export * from "./confirm-consolidation.vue?vue&type=script&lang=js"
import style0 from "./confirm-consolidation.vue?vue&type=style&index=0&id=048a00a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a00a6",
  null
  
)

export default component.exports